import React from "react";
import WarningTriangleIcon from "../images/WarningTriangleIcon.svg";
import SmallSizedModal from "../utils/UI/SmallSizedModal";
import { Box } from "@mui/material";

const MaintenanceDialog = () => {
    return (
        <>
            <SmallSizedModal
                open={true}
                headingIcon={WarningTriangleIcon}
                headingText={"Ongoing maintenance"}
            >
                <Box>
                    SCHEDULED MAINTENANCE IN PROGRESS - TUESDAY, March 04, 2025,
                    6:30PM - 8:30PM (EST)
                </Box>
                <Box>
                    Our system will be temporarily unavailable on Tuesday, March
                    04, while we perform planned system maintenance Our system
                    will be temporarily unavailable on Tuesday, March 04, while
                    we perform planned system maintenance
                </Box>
            </SmallSizedModal>
        </>
    );
};

export default MaintenanceDialog;
